import React from 'react'
import * as d3 from "../d3.modified.js"

export default class MarkerNode extends React.PureComponent {
    constructor(props) {
        super(props)
        // this.isJustClickNotDrag = false
        this.props.nodeItem.refs = {}
        this.props.nodeItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleMove: this.styleMove,
            styleFade: this.styleFade
        }
    }

    componentDidMount() {
        var node = this.props.nodeItem

        if (node._selectionId!==-1) {
            this.styleSelect()
        }

        const _step = 10

        node.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        this.position = undefined;
        node.refs.holder.call(d3.drag()
            .on('start', ()=>{
                this.position = {x:d3.event.x, y:d3.event.y}
                this.props.hideCtxMenus()

                // <grided>
                this.startDragMPosX = d3.event.x
                this.startDragMPosY = d3.event.y
                this.startDragPosX = node.x
                this.startDragPosY = node.y
                // </grided>

                this.props.dragStartHandler()
            })
            .on('drag', ()=>{
                node.refs.holder.classed('moving', true)
                if (node._selectionId === -1) {
                    this.props.clickHandler(node, true)
                }
                if ((!this.props.keyPressDict.link || (this.props.keyPressDict.link && node._selectionId!==-1)) && (!this.props.keyPressDict.ctrl || node._selectionId !== -1)) {
                    // <grided>
                    if (this.props.keyPressDict.grid) {
                        let x = this.startDragPosX + (d3.event.x-this.startDragMPosX)-7//-node.width*0.5
                        let y = this.startDragPosY + (d3.event.y-this.startDragMPosY)-7//-node.height*0.5
                        x = parseInt((x+_step/2)/_step)*_step
                        y = parseInt((y+_step/2)/_step)*_step

                        let dx = x-node.x+7//+node.width*0.5
                        let dy = y-node.y+7//+node.height*0.5
                        this.props.dragHandler(dx, dy)
                    } else {
                    // </grided>
                        this.props.dragHandler(d3.event.dx, d3.event.dy)
                    }
                }
            })
            .on('end', ()=>{
                node.refs.holder.classed('moving', false)
                let newPosition = {x:d3.event.x, y:d3.event.y}
                    if ((newPosition.x !== this.position.x) || (newPosition.y !== this.position.y) ) {
                        this.props.dragEndHandler()
                    }
            })
        )

        node.refs.holder
            .on('mouseenter', ()=>{
                if (this.props.keyPressDict.link) {
                    if (this.props.canCreateLink(node)) {
                        node.refs.holder.classed('linkage-can', true)
                    } else {
                        node.refs.holder.classed('linkage-cannot', true)
                    }
                }
            })
            .on('mouseleave', ()=>{
                if (this.props.keyPressDict.link) {
                    node.refs.holder.classed('linkage-can', false)
                    node.refs.holder.classed('linkage-cannot', false)
                }
            })

        node.refs.holder
            .on("click", ()=>{
                if (this.props.keyPressDict.link) {
                    this.props.createLink(node)
                } else {
                    this.props.clickHandler(node)
                }
                d3.event.stopPropagation()
            })
    }

    componentDidUpdate() {

    }

    styleMove = () => {
        var node = this.props.nodeItem
        this.props.enqueueAttrChange({
            elem: node.refs.holder,
            attr: 'transform',
            val: `translate(${node.x} ${node.y})`
        })
    }

    styleSelect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.holder,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.holder,
            class: 'active',
            val: false,
        })
    }

    styleFade = () => {
        this.props.nodeItem.refs.holder
            .transition()
                .duration(400)
                .style('opacity', 0)
    }

    render() {
        var node = this.props.nodeItem

        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        return (
            <g
                className="node-holder node-marker-holder"
                transform={`translate(${node.x} ${node.y})`}
                ref={c=>node.refs.holder=d3.select(c)}
                opacity="0"
            >
            {/* MARKERS */}
                <circle r="7px" className="node-marker-edge" ref={c=>node.refs.markerEdge=d3.select(c)} id={`N_${node.id}_me`}/>
                <circle r="4px" className="node-marker" ref={c=>node.refs.marker=d3.select(c)} id={`N_${node.id}_m`} style={{fill: node._compareType?diffColors[node._compareType]:node.properties.color}}/>
            {/* FIELDS */}
                <text x="10" y="10" className="node-text" alignmentBaseline="hanging" id={`N_${node.id}_txt`}>{node.properties.title}</text>
                {/*<text x="10" y="30" className="node-text" alignmentBaseline="hanging">{node.properties.description}</text>*/}
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nodes/MarkerNode.js